import PublicItemsLocker from './PublicItemsLocker';
import './PublicItemsLocker.scss';

export default PublicItemsLocker;
